
<template>
	<div ref="listWrap">
		<wrapper-list 
        @calculate="paasCalculate"      
		ref="wrapperList" >
      	<Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
          <row class="list-query-row">
            <FormItem label="提现人:" class="list-query-item">
              <Input  v-model="queryParam.query_LIKE_nickname"
                      @on-change="queryTableDatas('param')" />

            </FormItem>
            <FormItem label="提现去向:" class="list-query-item">
              <Enum :enumJsonKey="'crmdict-moneyType'"  v-model="queryParam.query_EQ_moneyType"
                    @on-change="queryTableDatas('param')" />
              </Enum>
            </FormItem>
          </row>

        </Form>
      	<Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
        </Table>
        <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
        </Page>
        </wrapper-list>
   </div>
</template>
<script>
	  import wrapperList from "@/components/paas/wrapper-list";
    import metaList from "@/assets/js/list/meta-list.js";
    import EnumShow from "@/components/paas/enum-show";  //如果有枚举，需要引入
    import CellBar from '@/components/paas/cell-bar' //列表内操作
    import Enum from '@/components/paas/query-enum' //枚举查询
    export default {
      name: "list",
      mixins: [ metaList ],
      components: { wrapperList,EnumShow,CellBar,Enum},
      data() {
      	return {
      		serviceUrl:"/member/withdrawal/record",  //每个页面访问后台服务器的路径
      		currentIdFiledName: 'id',
            queryParam:{
                query_LIKE_nickname:'',
                query_EQ_moneyType:'',
                queryOrderBy_: 'timeWithdraw@desc',
            },
	        defaultLabelWidth:200,
	         tableColumns:[
	        	{
	        		title: '用户名称',
	        		key: 'nickname',
	        	},
	        	{
	        		title: '提现时间',
	        		key: 'timeWithdraw',
	        	},
	        	{
	        		title: '提现金额',
	        		key: 'withdrawalPrice',
	        	},
	        	{
	        		title: '提现去向',
	        		key: 'moneyType',
	        		render:(h,params)=>{
		                return h(EnumShow,{
		                  props:{
		                    enumGroupCode:'crmdict',
		                    enumCode:'moneyType',
		                    value:params.row.moneyType
		                  }
		                })
		            }
	        	},
	        ],
      	}
      },
      mounted(){
      },
      methods:{
      }
    } 
</script>
